import RegLegalPerson from "./RegLegalPerson"

export default  RegLegalPerson;
